export default {"src":"/_next/static/media/sort-up-icon.bab4e2b1.svg","height":512,"width":513};